export const passCodes = [
    '^jo[s|š]t$',
    '^c$',
    '^labyrint$',
    '^krt(ek)?$',
    '^je[ž|z](ek)?$',
    '^sn[í|i]h$',
    '^hokuspokussimsalabim$',
    '^bohpodsvetiah[a|á]des$',
    '^5(,)?8$',
];
